module.exports = __webpack_public_path__ + "38703b8226524f5fcb571f8e2e5b650d.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_2@2x.png
// module id = 213
// module chunks = 1